export default __webpack_public_path__ + "static/media/1_0126.8846751b.webp";